<template>

  <div>

    <template v-if="!isMobile">

        <section class="row margin-b-100">

            <header class="shop__header margin-b-50">

                <h1>Bestilling</h1>

                <p>Vælg det ønskede antal bestillinger.</p>

                <!-- <strong>OBS! Ønsker du levering skal der bestilles over tlf. 66120510.</strong></p> -->

            </header>

            <section class="shop-form">

                <div class="shop-form__row">

                  <div class="col-5">

                    <p>{{product.title}}</p>

                  </div>

                  <div class="col-3">

                    <div class="shop__btn">

                        <button @click.prevent="removeFromProductQuantity" id="product-substract">-</button>

                        <input class="shop__input--number" type="number" name="product-amount" :value="orderDetails.product.quantity" disabled="disabled">

                        <button @click.prevent="addToProductQuantity" id="product-add">+</button>

                    </div>

                  </div>

                  <div class="col-4 right">

                    <p>{{formatCurrency(orderDetails.product.quantity * orderDetails.product.price)}}<span>DKK</span></p>

                  </div>

                </div>

            </section>

        </section>

        <section class="row margin-b-100" v-if="hasSubProducts">

            <header class="shop__header margin-b-50">

                <h1>Tilkøb</h1>

                <p>Vælg hvilke tilkøb, samt antallet af disse, du ønsker at bestille.</p>

            </header>

            <section class="shop-form">

                <div class="shop-form__row" v-for="(subProduct, index) in orderDetails.subProducts" :class="{'margin-t-50':(index > 0)}">

                  <div class="col-5">

                    <p>{{subProduct.title}}</p>

                  </div>

                  <div class="col-3">

                    <div class="shop__btn">

                        <button @click.prevent="removeFromSubProductQuantity(subProduct)" class="sub-substract">-</button>

                        <input type="number" class="shop__input--number" name="sub-amount" :value="subProduct.quantity" disabled="disabled">

                        <button @click.prevent="addToSubProductQuantity(subProduct)" class="sub-add">+</button>

                    </div>

                  </div>

                  <div class="col-4 right">

                    <p>{{formatCurrency(subProduct.price * subProduct.quantity)}}<span>DKK</span></p>

                  </div>

                </div>

            </section>

        </section>

        <section class="row margin-b-50">

            <header class="shop__header margin-b-50">

                <h1>Din samlede pris</h1>

                <p>Se din samlede pris, antal og evt. tilkøb, for din bestilling.</p>

            </header>

            <div class="table">

                <section class="table__header base-color-30">

                    <section class="table__item--lg">

                        <p>Produkt navn</p>

                    </section>

                    <section class="table__item--sm">

                        <p>Antal</p>

                    </section>

                    <section class="table__item--sm">

                        <p>Pris</p>

                    </section>

                </section>

                <section class="table__body">

                    <section class="table__row">

                        <section class="table__item--lg">

                            <p>{{product.title}}</p>

                        </section>

                        <section class="table__item--sm">

                            <p>{{orderDetails.product.quantity}}</p>

                        </section>

                        <section class="table__item--sm">

                            <p>{{formatCurrency(orderDetails.product.quantity *
                                orderDetails.product.price)}}<span>DKK</span></p>

                        </section>

                    </section>

                    <template v-for="subProduct in orderDetails.subProducts">

                        <section class="table__row" v-if="subProduct.quantity > 0">

                            <section class="table__item--lg">

                                <a class="delete" href="#" @click.prevent="clearSubProductQuantity(subProduct)"><img src="/images/delete-icon.svg" alt="Slet"/></a>

                                <p>{{subProduct.title}}</p>

                            </section>

                            <section class="table__item--sm">

                                <p>{{subProduct.quantity}}</p>

                            </section>

                            <section class="table__item--sm">

                                <p>{{formatCurrency(subProduct.price * subProduct.quantity)}}<span>DKK</span></p>

                            </section>

                        </section>

                    </template>

                    <!-- spacer row -->

                    <section class="table__row padding-tb-15">

                        <section class="table__item--lg">

                        </section>

                        <section class="table__item--sm">

                        </section>

                        <section class="table__item--sm">

                        </section>

                    </section>

                    <!-- total price row -->

                    <section class="table__row">

                        <section class="table__item--lg">

                            <p><strong>Samlet pris uden moms</strong></p>

                        </section>

                        <section class="table__item--sm">

                        </section>

                        <section class="table__item--sm">

                            <p><strong>{{formatCurrency(totalWithoutTaxes)}}<span>DKK</span></strong></p>

                        </section>

                    </section>


                    <section class="table__row">

                        <section class="table__item--lg">

                            <p><strong>Moms</strong></p>

                        </section>

                        <section class="table__item--sm">

                        </section>

                        <section class="table__item--sm">

                            <p><strong>{{formatCurrency(totalTaxes)}}<span>DKK</span></strong></p>

                        </section>

                    </section>

                    <section class="table__row">

                        <section class="table__item--lg">

                            <p><strong>Samlet pris</strong></p>

                        </section>

                        <section class="table__item--sm">

                        </section>

                        <section class="table__item--sm">

                            <p><strong>{{formatCurrency(totalWithTaxes)}}<span>DKK</span></strong></p>

                        </section>

                    </section>

                </section>

            </div>

        </section>

        <section class="row border-t padding-t-50 right">

            <a href="" class="btn--primary" @click.prevent="nextStep">Gå til Betalingsoplysninger</a>

        </section>

    </template>




      <!-- Mobile version -->

      <template v-if="isMobile">

        <section class="row margin-b-100">

            <header class="shop__header margin-b-50 center">

              <h1>Bestilling</h1>

              <p>Nedenfor kan du vælge hvilke antal du ønsker at bestille.<br> Klik på + for at lægge til, eller - for at trække fra.</p>

            </header>

            <section class="shop-form">

                <div class="shop-form__row">

                  <div class="col-12 margin-b-25">

                    <p>{{product.title}}</p>

                  </div>

                  <div class="col-12 flex margin-b-25">

                    <div class="shop__btn">

                        <button @click.prevent="removeFromProductQuantity">-</button>

                        <input class="shop__input--number" type="number" name="amount" :value="orderDetails.product.quantity" disabled="disabled">

                        <button @click.prevent="addToProductQuantity">+</button>

                    </div>

                  </div>

                  <div class="col-12">

                    <p>{{formatCurrency(orderDetails.product.quantity * orderDetails.product.price)}}<span>DKK</span></p>

                  </div>

                </div>

            </section>

        </section>

        <section class="row margin-b-100" v-if="hasSubProducts">

            <header class="shop__header margin-b-50 center">

                <h1>Tilkøb</h1>

                <p>Nedenfor kan du vælge hvilke tilkøb, samt antallet af disse, du ønsker at bestille. <br>
                    Et tilkøb er først registreret, når et antal er valgt.</p>

            </header>

            <section class="shop-form margin-b-25">

                <div class="shop-form__row" v-for="(subProduct, index) in orderDetails.subProducts" :class="{'margin-t-50':(index > 0)}">

                  <div class="col-12">

                    <p>{{subProduct.title}}</p>

                  </div>

                  <div class="col-12 flex margin-b-25">

                    <div class="shop__btn">

                        <button @click.prevent="removeFromSubProductQuantity(subProduct)">-</button>

                        <input type="number" class="shop__input--number" name="amount" :value="subProduct.quantity" disabled="disabled">

                        <button @click.prevent="addToSubProductQuantity(subProduct)">+</button>

                    </div>

                  </div>

                  <div class="col-12">

                    <p>{{formatCurrency(subProduct.price * subProduct.quantity)}}<span>DKK</span></p>

                  </div>

                </div>

            </section>

        </section>

        <section class="row margin-b-50">

            <header class="shop__header margin-b-50 center">

                <h1>Din samlede pris</h1>

                <p>Nedenfor kan du se din samlede pris, antal og evt. tilkøb for din bestilling.
                  Ønsker du at fjerne et tilkøb, kan du klikke på krydset ud fra dette.</p>

            </header>

            <div class="table">

                <section class="table__header base-color-30">

                    <section class="table__item--lg">

                        <h3>Dine varer</h3>

                    </section>

                </section>

                <section class="table__body">

                    <section class="table__row">

                        <section class="table__item--lg">

                            <p>{{product.title}}</p>

                        </section>

                        <section class="table__item--lg">

                            <p>{{orderDetails.product.quantity}}<span>stk.</span></p>

                        </section>

                        <section class="table__item--lg">

                            <p>{{formatCurrency(orderDetails.product.quantity *
                                orderDetails.product.price)}}<span>DKK</span></p>

                        </section>

                    </section>

                    <template v-for="subProduct in orderDetails.subProducts">

                        <section class="table__row" v-if="subProduct.quantity > 0">

                            <section class="table__item--lg">

                                <a class="remove" href="#" @click.prevent="clearSubProductQuantity(subProduct)"><img src="/images/delete-icon.svg" alt="Slet"/></a>

                                <p>{{subProduct.title}}</p>

                            </section>

                            <section class="table__item--lg">

                                <p>{{subProduct.quantity}}<span>stk.</span></p>

                            </section>

                            <section class="table__item--lg">

                                <p>{{formatCurrency(subProduct.price * subProduct.quantity)}}<span>DKK</span></p>

                            </section>

                        </section>

                    </template>

                    <!-- spacer row -->

                    <section class="table__row padding-tb-15">

                        <section class="table__item--lg">

                        </section>

                    </section>

                    <!-- total price row -->

                    <section class="table__row">

                        <section class="table__item--lg">

                            <p>Samlet pris uden moms</p>

                        </section>

                        <section class="table__item--lg">

                            <p><strong>{{formatCurrency(totalWithoutTaxes)}}<span>DKK</span></strong></p>

                        </section>

                    </section>


                    <section class="table__row">

                        <section class="table__item--lg">

                            <p>Moms</p>

                        </section>

                        <section class="table__item--lg">

                            <p><strong>{{formatCurrency(totalTaxes)}}<span>DKK</span></strong></p>

                        </section>

                    </section>

                    <section class="table__row">

                        <section class="table__item--lg">

                            <p>Samlet pris</p>

                        </section>

                        <section class="table__item--lg">

                            <p><strong>{{formatCurrency(totalWithTaxes)}}<span>DKK</span></strong></p>

                        </section>

                    </section>

                </section>

            </div>

        </section>

        <section class="row border-t padding-tb-50 right">

          <a href="" class="btn--primary" @click.prevent="nextStep">Gå til Betalingsoplysninger</a>

        </section>

      </template>

  </div>

</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    export default {
        data: function () {
            return {
                screenWidth:0
            }
        },
        computed: {
            ...mapGetters({
                product: 'getProduct',
                subProducts: 'getSubProducts',
                orderDetails: 'getDetails'
            }),
            hasSubProducts(){
                return this.subProducts.length > 0;
            },
            totalWithTaxes(){
                var productTotal = this.orderDetails.product.quantity * this.orderDetails.product.price;
                var subProductsTotal = 0;

                if (this.orderDetails.subProducts.length > 0) {
                    subProductsTotal = this.orderDetails.subProducts.map(function (item, index) {
                        return item.quantity * item.price;
                    }).reduce(function (a, b) {
                        return a + b
                    }, 0);
                }

                return productTotal + subProductsTotal;
            },
            totalTaxes(){
                return this.totalWithTaxes - this.totalWithoutTaxes;
            },
            totalWithoutTaxes(){
                return this.totalWithTaxes / 1.25;
            },
            isMobile(){
                return this.screenWidth <= 568;
            }

        },
        methods: {
            ...mapActions(['setStep', 'setDetails']),

            addToProductQuantity(){
                if (this.orderDetails.product.quantity < this.product.current_quantity) {
                    this.orderDetails.product.quantity += 1;
                }

                 this.updateDetails();
            },
            removeFromProductQuantity(){
                if (this.orderDetails.product.quantity > 1) {
                    this.orderDetails.product.quantity -= 1;
                }

                this.orderDetails.subProducts.map((item, index)=>{
                    if(item.quantity > this.orderDetails.product.quantity)
                    {
                        item.quantity = this.orderDetails.product.quantity;
                    }
                    return item;
                });

                 this.updateDetails();
            },
            addToSubProductQuantity(subProduct){
              /*if(subProduct.quantity < this.orderDetails.product.quantity){
                  subProduct.quantity += 1;
              }*/

               subProduct.quantity += 1;

               this.updateDetails();
            },
            removeFromSubProductQuantity(subProduct){
                if(subProduct.quantity > 0)
                {
                    subProduct.quantity -= 1;
                }

                 this.updateDetails();
            },
            clearSubProductQuantity(subProduct){
                subProduct.quantity = 0;

                 this.updateDetails();
            },
            formatCurrency(number){
                var formatter = new Intl.NumberFormat('da-DK', {
                    style: 'decimal',
                    currency: 'DKK',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                var stripePrice = number / 100;

                return formatter.format(stripePrice);
            },
            getSubProductById(id){
                return this.subProducts.filter(function(item, index){
                    return item.id == id;
                })[0];
            },
            updateDetails(){
                this.setDetails(this.orderDetails);
            },
            nextStep(){
                this.$ua.trackEvent('Link', 'Click', 'Shop - Step 1 - Details');
                this.setStep(1);
            }
        },
        beforeMount(){
            this.screenWidth = window.innerWidth;

            window.addEventListener('resize', (event)=>{
                this.screenWidth = window.innerWidth;
            });
        }
    }
</script>
